import React, { useState, useEffect } from "react";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";
import { ReactComponent as IconEye } from "../../../../shared/assets/Icons/Icon_Eye.svg";
import { columns as baseColumns, LastMile } from "./LmData";
import GenericButton from "@ui-components/Button/GenericButton";
import { GenericTable } from "@ui-components/Table/GenericTable";
import { ReactComponent as IconPlus } from "../../../../shared/assets/Icons/IconPlusV3.svg";
import GenericModal from "@ui-components/Modal/GenericModal";
import GenericInput from "@ui-components/Input/GenericInput";
import {
	getLastMiles,
	getLastMilebyId,
	updateLastMile,
	addLastMile,
	getVendorsList,
	deleteLastMile,
} from "./request/request";
import { useAuth0 } from "@auth0/auth0-react";
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown";
import GenericAlert from "@ui-components/Alert/GenericAlert";
interface Vendor {
	id: number;
	name: string;
}

function LastMileInventoryPage() {
	// ========= 1) Table data =========
	const [lastMiles, setLastMiles] = useState<LastMile[]>([]);

	// Optional: track loading/spinner
	const [isFetching, setIsFetching] = useState(false);

	// ========= 2) Add/Edit modal state & fields =========
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editMode, setEditMode] = useState(false);

	// Fields for Add/Edit (matching your LastMile interface)
	const [lmIdCharge, setLmIdCharge] = useState<string>("");
	const [lmName, setLmName] = useState<string>("");
	const [lmVendorId, setLmVendorId] = useState<number>(0);
	const [lmState, setLmState] = useState<string>("");
	const [lmCity, setLmCity] = useState<string>("");
	const [lmCountryId, setLmCountryId] = useState<string>("");
	const [lmZipStart, setLmZipStart] = useState<string>("");
	const [lmZipEnd, setLmZipEnd] = useState<string>("");
	const [lmId, setLmId] = useState<number>(0);
	const [vendorOptions, setVendorOptions] = useState<Vendor[]>([]);

	// ========= 3) View modal state =========
	const [isViewModalOpen, setIsViewModalOpen] = useState(false);
	const [selectedLM, setSelectedLM] = useState<LastMile | null>(null);

	// ========= 4) Delete confirmation state (if desired) =========
	const [isAlertOpen, setIsAlertOpen] = useState(false);
	const [lmToDelete, setLmToDelete] = useState<LastMile | null>(null);

	// ========== Auth0 para obtener token y llamar a nuestros endpoints ==========
	const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
	// ------------------------------------------------------------------------------------
	// useEffect: call GET /lastMiles on mount
	// ------------------------------------------------------------------------------------
	useEffect(() => {
		if (isLoading) return;
		if (!isAuthenticated) return;
		fetchAllLastMiles();
	}, [isLoading, isAuthenticated]);

	//GET Vendors List To map data on select
	useEffect(() => {
		(async () => {
			try {
				const token = await getAccessTokenSilently();
				const resp = await getVendorsList(token);
				setVendorOptions(resp.data);
			} catch (error) {
				console.error("Error fetching vendors:", error);
			}
		})();
	}, [getAccessTokenSilently]);


	// Convert each vendor object to a label for the dropdown
	const vendorLabels = vendorOptions.map((v) => v.name);
	// A) Convert vendorId -> vendor name
	function getVendorNameById(vendorId: number): string {
		const match = vendorOptions.find((v) => v.id === vendorId);
		return match ? match.name : "";
	}

	// B) Convert vendor name -> vendor ID
	function handleSelectVendorName(selectedName: string) {
		const match = vendorOptions.find((v) => v.name === selectedName);
		setLmVendorId(match ? match.id : 0);
	}

	const countryOptions = [
		{ label: "Mexico", value: "MX" },
		// If you need more options in the future, add them here.
	];
	// Convert your object array to a simple array of strings (the labels):
	const countryLabels = countryOptions.map((opt) => opt.label);

	function getCountryLabelByValue(value: string): string {
		const match = countryOptions.find((opt) => opt.value === value);
		return match ? match.label : ""; // if no match, return ""
	}
	function handleSelectCountryLabel(selectedLabel: string) {
		const match = countryOptions.find((opt) => opt.label === selectedLabel);
		setLmCountryId(match ? match.value : "");
	}

	const fetchAllLastMiles = async () => {
		try {
			setIsFetching(true);
			const token = await getAccessTokenSilently();
			const response = await getLastMiles(token);
			setLastMiles(response.data);
		} catch (error) {
			console.error("Error fetching last miles:", error);
		} finally {
			setIsFetching(false);
		}
	};

	// ------------------------------------------------------------------------------------
	// Handle ADD
	// ------------------------------------------------------------------------------------
	const handleAddLM = () => {
		setEditMode(false);
		// Clear fields
		setLmIdCharge("");
		setLmVendorId(0);
		setLmState("");
		setLmCity("");
		setLmCountryId("");
		setLmZipStart("");
		setLmZipEnd("");
		setLmName("");
		setIsModalOpen(true);
	};

	// ------------------------------------------------------------------------------------
	// Handle EDIT
	// ------------------------------------------------------------------------------------
	const handleEditLM = async (lm: LastMile) => {
		try {
			setEditMode(true);
			// Optionally fetch fresh data from the API to ensure up-to-date details

			const token = await getAccessTokenSilently();
			const response = await getLastMilebyId(token, lm.id);
			const data = response.data;

			// Fill your form fields
			setLmIdCharge(data.idCharge);
			setLmVendorId(data.vendorId ?? 0);
			setLmState(data.state);
			setLmCity(data.city);
			setLmCountryId(data.countryId);
			setLmZipStart(data.zip_start);
			setLmZipEnd(data.zip_end);
      setLmId(data.id)
      setLmName(data.name)

			setIsModalOpen(true);
		} catch (error) {
			console.error("Error fetching last mile details:", error);
		}
	};

	// ------------------------------------------------------------------------------------
	// Handle SAVE (ADD / UPDATE)
	// ------------------------------------------------------------------------------------
	const handleSaveLastMile = async () => {
		try {
			setIsFetching(true);

			// Build payload from your state fields
			const payload: LastMile = {
				id: lmId,
				idCharge: lmIdCharge,
				vendorId: lmVendorId,
				state: lmState,
				city: lmCity,
				countryId: lmCountryId,
				zip_start: lmZipStart,
				zip_end: lmZipEnd,
        name: lmName
			};

			if (editMode) {
				// Update
				const token = await getAccessTokenSilently();
				await updateLastMile(token, lmId, payload);
			} else {
				// Add
				const token = await getAccessTokenSilently();
				await addLastMile(token, payload);
			}

			// Refresh table
			await fetchAllLastMiles();
		} catch (error) {
			console.error("Error saving Last Mile:", error);
		} finally {
			setIsFetching(false);
		}
		setIsModalOpen(false);
	};

	// ------------------------------------------------------------------------------------
	// Handle VIEW
	// ------------------------------------------------------------------------------------
	const handleViewLM = async (lm: LastMile) => {
		try {
			const token = await getAccessTokenSilently();
			const response = await getLastMilebyId(token, lm.id);
			setSelectedLM(response.data);
			setIsViewModalOpen(true);
		} catch (error) {
			console.error("Error viewing last mile:", error);
		}
	};

	// ------------------------------------------------------------------------------------
	// Handle DELETE (placeholder)
	// ------------------------------------------------------------------------------------
	const handleDeleteLM = async (lm: LastMile) => {
		setLmToDelete(lm);
		setIsAlertOpen(true);
	};

	const handleCancelDelete = () => {
		setLmToDelete(null);
		setIsAlertOpen(false);
	};

	const handleConfirmDelete = async () => {
		if (!lmToDelete) return;
		try {
			setIsFetching(true);
			const token = await getAccessTokenSilently();
			await deleteLastMile(token, lmToDelete.id);

			setLastMiles((prev) => prev.filter((item) => item.id !== lmToDelete.id));
			setLmToDelete(null);
			setIsAlertOpen(false);
		} catch (error) {
			console.error("Error deleting last mile", error);
		} finally {
			setIsFetching(false); 
		}
	};

	// ------------------------------------------------------------------------------------
	// Override "Actions" column
	// ------------------------------------------------------------------------------------
	const columns = baseColumns.map((col) => {
		if (col.header === "Actions" && col.renderCell) {
			return {
				...col,
				renderCell: (row: LastMile) => (
					<div className="flex items-center gap-2">
						{/* View */}
						<button
							className="
                flex items-center justify-center
                border border-semantic-border-secondary
                rounded
                text-semantic-text-secondary
                hover:bg-semantic-state-active
                w-10 h-10
              "
							onClick={() => handleViewLM(row)}
						>
							<IconEye className="w-6 h-6" />
						</button>

						{/* Edit */}
						<button
							className="
                flex items-center justify-center
                border border-semantic-border-secondary
                rounded
                text-semantic-text-secondary
                hover:bg-semantic-state-active
                w-10 h-10
              "
							onClick={() => handleEditLM(row)}
						>
							<IconEdit className="w-10 h-10" />
						</button>

						{/* Delete */}
						<button
							className="
                p-2
                border border-semantic-border-secondary
                rounded
                bg-red-50
                text-red-600
                hover:bg-red-100
              "
							onClick={() => handleDeleteLM(row)}
						>
							<IconDelete className="w-6 h-6" />
						</button>
					</div>
				),
			};
		}
		return col;
	});

	return (
		<div className="relative p-4">
			{/* Header */}
			<div className="mb-4 p-4 bg-[var(--semantic-bg-primary)]">
				<div className="flex items-end justify-between">
					<div className="flex items-end space-x-4"></div>
					<GenericButton
						label={
							<div className="flex items-center gap-2">
								<IconPlus className="w-4 h-4" />
								<span>Add new Last Mile</span>
							</div>
						}
						variant="brand"
						size="md"
						onClick={handleAddLM}
					/>
				</div>
			</div>

			{/* Table */}
			<GenericTable
				columns={columns}
				data={lastMiles}
				initialRowsPerPage={5}
				rowsPerPageOptions={[5, 10]}
				tableClassName="bg-[var(--semantic-bg-primary)]"
				width="100%"
			/>

			{/* ====================== Modal Add / Edit ====================== */}
			<GenericModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				title={editMode ? "Edit Last Mile" : "Add Last Mile"}
				size="lg"
			>
				<div className="grid grid-cols-3 gap-4 mb-4">
					<GenericInput
						label="idCharge"
						value={lmIdCharge}
						onChange={setLmIdCharge}
						readOnly={editMode} // e.g. not editable in Edit mode
					/>
					<div className="flex flex-col space-y-2">
						<label className="text-sm font-medium">Vendor</label>
						<GenericDropdown
							items={vendorLabels}
							value={getVendorNameById(lmVendorId)}
							onSelect={handleSelectVendorName}
							defaultLabel="Select a vendor..."
							widthClass="w-full"
						/>
					</div>

					<GenericInput
						label="Name"
						value={lmName}
						onChange={setLmName}
						placeholder="e.g. Last Mile 1"
					/>
					<GenericInput
						label="State"
						value={lmState}
						onChange={setLmState}
						placeholder="e.g. Queretaro"
					/>

					<GenericInput
						label="City"
						value={lmCity}
						onChange={setLmCity}
						placeholder="e.g. Queretaro"
					/>
					<div className="flex flex-col space-y-2">
						<label className="text-sm font-medium">Country ID</label>
						<GenericDropdown
							items={countryLabels}
							value={getCountryLabelByValue(lmCountryId)}
							labelKey="label"
							onSelect={handleSelectCountryLabel}
							// A default placeholder when nothing is selected
							defaultLabel="Select a Country"
							widthClass="w-full"
						/>
					</div>

					<GenericInput
						label="Zip Start"
						value={lmZipStart}
						onChange={setLmZipStart}
						placeholder="e.g. 90001"
					/>

					<GenericInput
						label="Zip End"
						value={lmZipEnd}
						onChange={setLmZipEnd}
						placeholder="e.g. 90099"
					/>
				</div>

				<div className="flex justify-end space-x-2">
					<button
						className="
              px-4 py-2
              text-sm
              font-medium
              text-semantic-text-secondary
              bg-semantic-bg-primary
              border border-semantic-border-secondary
              rounded
              hover:bg-semantic-state-active
              transition-colors
            "
						onClick={() => setIsModalOpen(false)}
					>
						Cancel
					</button>
					<button
						className="
              px-4 py-2
              text-sm
              font-medium
              text-white
              bg-semantic-text-brand
              rounded
              hover:bg-opacity-90
              transition-colors
            "
						onClick={handleSaveLastMile}
					>
						Save
					</button>
				</div>
			</GenericModal>

			{/* ====================== Modal View (Read-Only) ====================== */}
			<GenericModal
				isOpen={isViewModalOpen}
				onClose={() => setIsViewModalOpen(false)}
				title="View Last Mile"
				size="md"
			>
				{selectedLM &&
					(() => {
						const vendorObj = vendorOptions.find(
							(v) => v.id === selectedLM.vendorId
						);
						const vendorName = vendorObj ? vendorObj.name : "Unknown Vendor";
						return (
							<div className="grid grid-cols-2 gap-4 mb-4">
								<GenericInput
									label="idCharge"
									value={selectedLM.idCharge}
									readOnly
								/>
								<GenericInput label="Name" value={selectedLM.name} readOnly />
								<GenericInput label="Vendor " value={vendorName} readOnly />
								<GenericInput label="State" value={selectedLM.state} readOnly />
								<GenericInput label="City" value={selectedLM.city} readOnly />
								<GenericInput
									label="Country ID"
									value={selectedLM.countryId}
									readOnly
								/>
								<GenericInput
									label="Zip Start"
									value={selectedLM.zip_start}
									readOnly
								/>
								<GenericInput
									label="Zip End"
									value={selectedLM.zip_end}
									readOnly
								/>
							</div>
						);
					})()}
				<div className="flex justify-end">
					<button
						className="
              px-4 py-2
              text-sm
              font-medium
              text-semantic-text-secondary
              bg-semantic-bg-primary
              border border-semantic-border-secondary
              rounded
              hover:bg-semantic-state-active
              transition-colors
            "
						onClick={() => setIsViewModalOpen(false)}
					>
						Close
					</button>
				</div>
			</GenericModal>

			{/* ====================== ALERT: confirm Delete ====================== */}
			<GenericAlert
				isOpen={isAlertOpen}
				onClose={handleCancelDelete}
				onConfirm={handleConfirmDelete}
				title="Are you sure?"
				description="This action cannot be undone. This will permanently delete the data center from the inventory."
				cancelLabel="Cancel"
				confirmLabel="Delete"
				iconWidthClass="w-20 h-12"
			/>
			{/* Optional: a delete confirmation modal if desired */}
			{isFetching && (
				<div
					className="
            fixed
            inset-0
            flex flex-col items-center justify-center
            bg-black/50
            z-[9999]
          "
				>
					<h2 className="text-xl font-semibold mb-4 text-white">
						Processing request...
					</h2>
					<div
						className="
              animate-spin
              rounded-full
              h-12 w-12
              border-4
              border-gray-300
              border-t-blue-500
            "
					/>
				</div>
			)}
		</div>
	);
}

export default LastMileInventoryPage;
